import {
  createRouter,
  createWebHistory,
  createWebHashHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SobreView from '../views/SobreView.vue'
import PasseiosView from '../views/PasseiosView.vue'
import ContatoView from '../views/ContatoView.vue'

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/sobre',
    name: 'sobre',
    component: SobreView
  },
  {
    path: '/passeios',
    name: 'passeios',
    component: PasseiosView,
    redirect: '/passeios/categorias',
    children: [{
        path: 'categorias',
        name: 'categorias',
        component: () => import('../views/CategoriaView.vue')
      },
      {
        path: 'cachoeiras',
        name: 'cachoeiras',
        component: () => import('../views/passeios/CachoeiraView.vue')
      },
      {
        path: 'balnearios',
        name: 'balnearios',
        component: () => import('../views/passeios/BalnearioView.vue')
      },
      {
        path: 'flutuacoes',
        name: 'flutuacoes',
        component: () => import('../views/passeios/FlutuacaoView.vue')
      },
      {
        path: 'aventuras',
        name: 'aventuras',
        component: () => import('../views/passeios/AventurasView.vue')
      },
      {
        path: 'bikes',
        name: 'bikes',
        component: () => import('../views/passeios/AventurasView.vue')
      },
      {
        path: 'contemplacoes',
        name: 'contemplacoes',
        component: () => import('../views/passeios/ContemplacaoView.vue')
      },
      {
        path: 'grutas',
        name: 'grutas',
        component: () => import('../views/passeios/GrutaView.vue')
      },
      {
        path: 'mergulhos',
        name: 'mergulhos',
        component: () => import('../views/passeios/SubAquaticaView.vue')
      },
      {
        path: 'cavalgadas',
        name: 'cavalgadas',
        component: () => import('../views/passeios/CavalgadaView.vue')
      },
    ]
  },
  {
    path: '/pacotes',
    name: 'pacotes',
    component: () => import('../views/PacotesView.vue')
  },
  {
    path: '/pacotes-bonitoms',
    name: 'pacotes-bonitoms',
    component: () => import('../views/PacotesView.vue')
  },
  {
    path: '/contato',
    name: 'contato',
    component: ContatoView
  },
  {
    path: '/hospedagem',
    name: 'hospedagem',
    component: () => import('../views/HospedagemView.vue'),
  },
  // {
  //   path: '/categoria',
  //   name: 'categoria',
  //   component: CategoriaView,
  // },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const GA_ID = 'G-VJ2ZQHWBDD'

router.afterEach((to) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }

  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_ID, {
      page_path: to.fullPath
    })
  }
})

export default router